module.exports = __webpack_public_path__ + "static/img/2960_phase_function_Paper_Points.a57e7b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2960_phase_function_Paper_Points.png
// module id = esw3
// module chunks = 0